import { OrgId } from "@ollie-sports/models";
import { getUniversalHelpers } from "../../helpers";
import { firestoreLiftQuerySubToBifrostSub } from "../../internal-utils/firestoreLiftSubToBifrostSub";

export function orgRegistrationPackage__client__getOrgRegistrationPackagesForOrgSubscription(p: { orgId: OrgId }) {
  const { ollieFirestoreV2: h } = getUniversalHelpers();

  return firestoreLiftQuerySubToBifrostSub(h.OrgRegistrationPackage.querySubscription({ where: [{ orgId: ["==", p.orgId] }] }));
}
